import React, { useMemo } from 'react';
import { isString, camelCase } from 'lodash';
import { isBrowser } from '@helpers';
import * as headings from '@heading';

export default function RawHTML({ html, children }) {
  const content = html ?? children;

  return !content ? null : (
    <React.Fragment>
      {isBrowser() ? (
        <Fragment html={content} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </React.Fragment>
  );
}

const Fragment = React.memo(({ html }) => {
  const content = useMemo(() => {
    let htmlString = html?.trim();

    if (!htmlString) {
      return null;
    }

    if (isString(htmlString)) {
      htmlString = htmlString
        .replace(/\[(.*)\]\((.*)\)/g, '<a href="$2">$1</a>')
        .replace(/\*\*(.*)\*\*/g, '<strong>$1</strong>');
    }

    const content = [];
    const div = document.createElement('div');
    div.innerHTML = htmlString;

    div.childNodes.forEach((node, index) => {
      if (node.nodeType === Node.TEXT_NODE) {
        content.push(node.textContent);
        return;
      }

      const Tag = headings[node.tagName] ?? node.localName;
      const props = {};

      node.getAttributeNames().forEach(name => {
        const key = reactPropNames[name] ?? camelCase(name);
        props[key] = node.getAttribute(name);
      });

      content.push(
        <Tag
          key={index}
          dangerouslySetInnerHTML={{ __html: node.innerHTML ?? '' }}
          {...props}
        />
      );
    });

    return content;
  }, [html]);

  return <React.Fragment>{content}</React.Fragment>;
});

const reactPropNames = {
  class: 'className',
  for: 'htmlFor'
};
